import Reflux  from 'reflux'

var actions = Reflux.createActions([
  'setData',
  'setFlag',
  'setProcessed',
  'setUnprocessed'
])

export default actions


// WEBPACK FOOTER //
// ./src/actions/bankactions.js